import React from "react";
import { Box, useMediaQuery, useTheme } from "@mui/material";

import { ColorBoxSettingsStateType, defaultSettings } from "./ColorBoxSettings";

interface ColorBoxPreviewProps {
  /**
   * State object represented by series of key value pairs,
   * where the key is a string which represents the title of the
   * updatable settings option.
   */
  settingsState: ColorBoxSettingsStateType | {};
}

export function ColorBoxPreview(props: ColorBoxPreviewProps) {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const currentState = {...defaultSettings, ...props.settingsState};

  return (
    <Box sx={{ width: isSmallScreen ? "100%" : "50%", height: isSmallScreen  ? "15vh" : "25vh" }}>
      <Box
        sx={{
          height: "100%",
          backgroundColor: currentState.colorValue,
          border: `1px solid ${theme.palette.action.disabled}`,
          borderRadius: theme.general.borderRadius
        }} />
    </Box>
  );
}